const ABFieldListCore = require("../../core/dataFields/ABFieldListCore");
module.exports = class ABFieldList extends ABFieldListCore {};
